var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-bar-wrapper"},[_c('transition',{attrs:{"name":"fadeBar"}},[(_vm.preloaderBarShow)?_c('div',{staticClass:"loader-bar"},[_c('div',{staticClass:"loader-bar__bar",class:_vm.animateClass})]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }